export enum ApplicationTab {
  InstalledApps = 0,
  AvailableApps = 1,
  Catalogs = 2,
  DockerImages = 3,
}
